<template>
  <div>

    <v-modal 
    class="sending-modal"
    v-model="modal_edit_open">
      <div class="container"
      style="padding: 10px; height: 100%;">
        <div class="rows is-full-height is-gapless">
          <div class="row is-narrow">
            <nav class="navbar primary"
            style="padding: 10px;">
              <span>Envoi</span>
            </nav>
          </div>
          <div class="row is-narrow">
            <div class="columns"
            style="width: 100%; padding-bottom: 10px; margin-bottom: 4px;">
              <div class="column is-3">
                <v-input class="floating-label full-width"
                v-model="msg.subject"
                placeholder="Sujet du message">
                </v-input>
              </div>
              <div class="column is-2">
                <v-input class="floating-label full-width"
                v-model="msg.from_mail"
                placeholder="Email de l'expéditeur">
                </v-input>
              </div>
              <div class="column is-3">
                <v-input class="floating-label full-width"
                v-model="msg.from_name"
                placeholder="Nom l'expéditeur">
                </v-input>
              </div>
              <div class="column is-4">

                <v-form-dropdown search fluid
                placeholder="Message"
                class="input-control no-overflow full-width"
                v-model="msg.message_id"
                :display="msg.message_title"
                :opened.sync="msg_dropdown.open"
                :filter="msg_dropdown.input"
                :items="msg_dropdown.items"
                :min_letters="0"
                displayKey='subject'
                @filter="set_message_items($event)"
                @input="on_message_select">
                </v-form-dropdown>
              </div>
            </div>
          </div>

          <div class="row is-narrow">
            <div class="columns"
            style="width: 100%; padding-bottom: 10px; margin-bottom: 4px;">

              <div class="column is-3"
              style="display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;">
                <v-form-dropdown search fluid
                placeholder="Ajouter un groupe d'emails dans l'envoi (label)"
                class="input-control no-overflow full-width"
                v-model="selected_group.id"
                :display="selected_group.name"
                :opened.sync="msg_group.label_opened"
                :filter="msg_group.input"
                :items="msg_group.items"
                :min_letters="0"
                @click.stop.prevent
                @filter="set_group_items($event)"
                @input="on_group_select">
                </v-form-dropdown>
                <div 
                class="button"
                title="Ajouter le label"
                style="
                float: right;
                padding: 0 0.6rem;
                margin-left: 0.6rem;
                "
                :style="{
                  color: (selected_group.id>0?'#363636':'#9d9d9d')
                }"
                v-no-select
                @click.prevent="on_group_add()">
                  <i class="plus"></i>
                </div>

              </div>
              
              <div class="column is-9">
                <fieldset style="height: 100%;">
                  <div v-for="group in msg.groups"
                  class="msg_group_tag">
                    <span v-html="group.name"></span>
                    <i class="times-circle"
                    @click.prevent="on_group_remove(group)"
                    ></i>
                  </div>
                </fieldset>

              </div>
            </div>
          </div>
          <!-- <div class="row" style="overflow: auto;">
            <vue-editor 
            style="width: 100%;"
            height="400px"
            :toolbar='toolbar'
            v-model="msg.content"></vue-editor>
          </div> -->
          <div class="row is-narrow">
            <nav class="navbar primary">
              <div
              class="button primary full-width"
              style="border: 0;"
              @click="save">Sauvegarder</div>
              </nav>
            </nav>
          </div>
        </div>
      </div>
    </v-modal>

    <div class="rows is-full-height is-gapless">
      <div class="row is-narrow">
        <nav class="navbar primary">
          <div class="navbar-nav search-nav">
            <div class="columns is-gapless">
              <div class="column is-5">
                <div class="button"
                @click="on_add_sending">
                  Nouvel envoi
                </div>
              </div>
              <div class="column is-5">
              </div>
            </div>
          </div>
        </nav>
      </div>
    </div>

     <div class="row border-row"
     style="padding: 0;"
      v-for="sending in sendings">
        <div class="list column is-24"
        style="position: relative; ">
          <div class="item">
            <div class="columns is-mobile">
              <div class="column is-4">
                <v-input class="floating-label full-width"
                :readonly="true"
                v-model="sending.subject"
                placeholder="Nom">
                </v-input>
              </div>
              <div class="column is-4">
                <v-input class="floating-label full-width"
                :readonly="true"
                :value="sending.groups_name_str"
                placeholder="Groupe">
                </v-input>
              </div>
              <div class="column is-2">
                <v-input class="floating-label full-width"
                :readonly="true"
                :value="getStatusText(sending)"
                placeholder="Status">
                </v-input>
              </div>
              <div class="column is-2"
              style="padding-top: 14px;">
                <div 
                class="button"
                title="Supprimer le message"
                style="float: right; margin-left: 10px;"
                v-no-select
                @click.prevent="on_del_item(sending)">
                  <i class="remove"></i>
                </div>
                <div 
                class="button"
                title="Éditer le message"
                style="float: right; margin-left: 10px;"
                v-no-select
                @click.prevent="on_set_item(sending)">
                  <i class="pencil"></i>
                </div>
                <div 
                v-if="sending.status==0"
                class="button"
                title="Démarrer l'envoi"
                style="float: right;"
                v-no-select
                @click.prevent="set_sent_status(sending, 1)">
                  <i class="play"></i>
                </div>
                <div 
                v-if="sending.status==1"
                class="button"
                title="Stopper l'envoi"
                style="float: right;"
                v-no-select
                @click.prevent="set_sent_status(sending, 0)">
                  <i class="pause"></i>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

  </div>
</template>
<script>
import Vue from 'vue'
import Vuex from 'vuex'
import typeahead from '../components/utils/typeahead.js'

export default {
  title: 'MailingSending',
  data: function () {
    return {
      msg: {
        id: 0,
        subject: '',
        content: '',
        from_mail: '',
        from_name: '',
        groups: [],
        groups_id: [],
        groups_name_str: '',
        message_id: 0,
        message_title: '',
        status: 0,
      },
      msg_dropdown: {
        opened: false,
        input: '',
        items: []
      },
      msg_group: {
        label_opened: false,
        input: '',
        items: []
      },
      sendings: [],
      messages: [],
      modal_edit_open: false,
      status_names: {
        '0': 'En attente',
        '1': 'En cours',
        '2': 'Terminé'
      },
      tot_mails: 0,
      selected_group: {
        id: 0,
        name: '',
      },
      message: {
        id: 0,
        name: '',
      },
      options: {
        stmp_host: '',
        stmp_port: 587,
        stmp_secure: 'tls',
        stmp_username: '',
        stmp_password: '',
        stmp_auth: 0,
        send_number: 50,
        from_mail: 'contact@fnepaca.fr',
        from_name: "FNE Provence-Alpes-Côte d'Azur"
      },
    }
  },
  computed: {
    ...Vuex.mapGetters({

    })
  },
  mounted: function () {
    var vm = this
    this.msg = this.get_blank_sending()
    this.get_sendings()
    // this.get_publications()


    var group_items = this.get_group_items(36, '')
    this.msg_group.items = group_items

    vm.get_sendings()
    vm.get_messages()
  },
  methods: {
    get_options: function () {
      var vm = this
      this.$http.post(
        global.app_path + 'main.php?action=get_options', {
          token: global.token
        }
      )
      .then((response) => {
        if(response &&
        response.body &&
        response.body.options) {
          vm.options = response.body.options
          for(name in response.body.options){
            vm.options[name] = response.body.options[name]
          }

          vm.msg.from_mail = vm.options.from_mail
          vm.msg.from_name = vm.options.from_name
        }
      }, (response) => {

      })
    },
    get_blank_sending: function(){
      return {
        id: 0,
        subject: '',
        content: '',
        from_mail: 'contact@fnepaca.fr',
        from_name: 'FNE Provence-Alpes-Côte d\'Azur',
        groups: [],
        groups_id: [],
        groups_name_str: '',
        message_id: 0,
        message_title: '',
        status: 0,
      }
    },
    getStatusText: function(msg){
        var status_text = this.status_names[msg.status]

        if(Number(msg.status)<2) {
          status_text += ' ('+msg.mail_done +'/'+ ((msg.to_everyone)?this.tot_mails:msg.mail_tot) +')'
        }

        return status_text
    },

    onSetEveryone: function(value, msg){
      if(value) {
        msg.group_name = 'Tout le monde'
      }
      else {
        // console.log(msg.group_id)
        var group = this.get_group_by_id(msg.group_id)
        // console.log('group', group)
        if(group) {
          msg.group_name = group.n
        }
        else {
          msg.group_name = 'Tout le monde'
        }
      }
      // console.log('onSetEveryone', value)
    },
    set_sent_status: function (sending, status) {
      var vm = this
      this.$http.post(
        global.app_path + 'main.php?action=set_sent_status', {
          msg_id: sending.id,
          status: Number(status),
          token: global.token
        }
      )
      .then((response) => {
        if(response && response.body && response.body.ok) {
          sending.status = status
        }
      }, (response) => {

      })
    },
    on_add_sending: function () {
      this.msg = this.get_blank_sending()
      this.msg_group.input = ''
      this.msg_group.opened = false

      this.modal_edit_open = true
    },
    // get_publications: function () {
    //   var vm = this
    //   this.$http.post(
    //     global.app_path + 'main.php?action=get_publications', {
    //       token: global.token
    //     }
    //   )
    //   .then((response) => {
    //     if(response &&
    //     response.body &&
    //     response.body.publications) {
    //       vm.publications = response.body.publications
    //       vm.publications_ref = {}
    //       vm.publications.forEach(function(p) {
    //         vm.publications_ref[p.id] = p
    //       })

    //     }
    //   }, (response) => {

    //   })
    // },
    get_sendings: function () {
      var vm = this
      this.$http.post(
        global.app_path + 'main.php?action=get_sendings', {
          token: global.token
        }
      )
      .then((response) => {
        if(response &&
        response.body &&
        response.body.sendings) {
          // response.body.sendings.forEach(function(sending){
            // sending.to_everyone = Boolean(Number(sending.to_everyone))

            // if (sending.to_everyone) {
            //   sending.group_name = 'Tout le monde'
            // }

            // sending.status_text = vm.status_names[sending.status]

            // if(Number(sending.status)<2) {
            //   sending.status_text += ' ('+sending.mail_done +'/'+ (sending.to_everyone)?tot_mails:sending.mail_tot +')'
            // }

            // +

            // sending.to_everyone = ((sending.to_everyone)?true:false)
          // })

          vm.sendings = response.body.sendings
          // vm.tot_mails = response.body.tot_mails
          // console.log("sendings", JSON.stringify(vm.sendings))
        }
      }, (response) => {

      })
    },

    get_messages: function () {
      var vm = this
      this.$http.post(
        global.app_path + 'main.php?action=get_messages', {
          is_template: 0,
          token: global.token
        }
      )
      .then((response) => {
        if(response &&
        response.body &&
        response.body.messages) {
          vm.messages = response.body.messages

          vm.msg_dropdown.items = vm.messages.slice(0, vm.messages.length)
        }
      }, (response) => {

      })
    },
    save: function () {
      var vm = this
      // var publication = this.get_publication_by_id(this.msg.publication_id)
      // let groups_id = []
      // this.msg.groups.forEach(function(group){
      //   groups_id.push(group.id)
      // })

      this.$http.post(
        global.app_path + 'main.php?action=set_sending', {
          id: this.msg.id,
          subject: this.msg.subject,
          from_mail: this.msg.from_mail,
          from_name: this.msg.from_name,
          message_id: this.msg.message_id,
          groups_id: this.msg.groups_id,
          token: global.token
        }
      )
      .then((response) => {
        if(Number(vm.msg.id) === 0) {
          var body = response.body
          vm.msg.id = Number(body.id)
          vm.sendings.unshift(vm.msg)
        }

        this.modal_edit_open = false
      }, (response) => {

      })
    },
    on_del_item: function () {

    },

    on_set_item: function (msg) {
      this.msg = msg
      this.modal_edit_open = true

    },

    send: function () {

    },

    /*** message ***/

    set_message_items: function (input) {
      // console.log('set_message_items', input)
      let str = input.toLowerCase()

      let items = []

      this.messages.forEach(function(message){
        if(message.subject.indexOf(str) != -1){
          items.push(message)
        }
      })

      this.msg_dropdown.items = items
    },



    on_message_select: function (group_id, group) {

      // console.log('on_message_select', group_id, group)
      // var group_index = window.groups_index.ref[group_id]
      // var group = window.groups_index.list[group_index]
      if(group){
        this.msg.message_id = group_id
        this.msg.message_title = group.subject
      }
    },

    /*** groups (lablel) ***/

    on_group_select: function (group_id, group) {
      // console.log('on_group_select', group_id, group)
      // var group_index = window.groups_index.ref[group_id]
      // var group = window.groups_index.list[group_index]
      if(group){
        this.selected_group.id = group_id
        this.selected_group.name = group.n
      }
    },

    on_group_add: function () {
      if(Number(this.selected_group.id) > 0){

        this.msg.groups.push({
          id: this.selected_group.id,
          name: this.selected_group.name,
        })

        this.msg.groups_id.push(this.selected_group.id)

        this.selected_group.id = 0
        this.selected_group.name = ''
      }
    },

    on_group_remove: function (group) {
      let group_index = this.msg.groups.indexOf(group)
      this.msg.groups.splice(group_index, 1)
      this.msg.groups_id.splice(group_index, 1)
    },

    set_group_items: function (input) {
      this.msg_dropdown.input = input

      // console.log('set_group_items', input, this)
      this.msg_group.items = this.get_group_items(36, input)
    },

    get_group_by_id: function(group_id){
      var group_index = window.groups_index.ref[group_id]
      return window.groups_index.list[group_index]
    },

    get_group_items: function (type, input) {
      let filter = null

      if (input === '') {
        if (Number(type) === 0) {
          return window.groups_index.list
        }

        if (window.groups_index.types[type]) {
          return typeahead.get_display(
            window.groups_index.types[type],
            window.groups_index
          )
        }

        return []
      }

      if (type > 0) {
        filter = function (item) {
          return item.type === type
        }
      }

      return typeahead.filter_list(
        input,
        window.groups_index,
        null,
        filter
      )
    },
  }
}
</script>
<style>
.ql-snow.ql-container {
  height: auto;
  /*overflow: hidden;*/
}

.modal-content {
  max-height: 100vh;
  height: 90vh;
}
.quillWrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.ql-container {
  flex: 1;
  overflow: auto;
}

.ql-snow .ql-editor {
  overflow: visible;
  height: 100%;
  min-height: auto;
}

.modal.sending-modal .modal-content {
  overflow: visible;
}

.msg_group_tag {
  display: inline-block;
  background: #1976d2;
  border-radius: 12px;
  border-color: rgba(0,0,0,.12);
  color: #fff;
  font-weight: bold;
  margin: 8px 4px;
  padding: 2px 8px;
  display: inline-flex;
  align-items: center;
}

.msg_group_tag i {
  margin-left: 4px;
  font-size: 18px;
  cursor: pointer;
}
</style>
